import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Public layout — anonymous routes (login, callback, marketplace, /u/:username).
 * No AuthGuard. T19 wires Auth0 SDK do login/callback components.
 */
export const Route = createFileRoute('/_public')({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <div className="min-h-dvh bg-[var(--color-bg-primary)] text-[var(--color-text-primary)]">
      <Outlet />
    </div>
  );
}
